"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _customProps = require("../../utils/customProps");

var _MuiIconButton = _interopRequireDefault(require("../MuiIconButton/MuiIconButton"));

var _MuiButton = _interopRequireDefault(require("../MuiButton/MuiButton"));

var _MuiHeroHeader = _interopRequireDefault(require("../MuiHeroHeader/MuiHeroHeader"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiMobileTab = _interopRequireDefault(require("./components/MuiMobileTab/MuiMobileTab"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoPlaySwipeableViews = (0, _reactSwipeableViewsUtils.autoPlay)(_reactSwipeableViews.default);

var MuiMobileStepper = function MuiMobileStepper(_ref) {
  var tabs = _ref.tabs,
      nextBtn = _ref.nextBtn,
      backBtn = _ref.backBtn,
      rootClass = _ref.rootClass,
      position = _ref.position,
      variant = _ref.variant,
      autoplay = _ref.autoplay,
      interval = _ref.interval;
  var components = {
    MuiIconButton: _MuiIconButton.default,
    MuiButton: _MuiButton.default,
    MuiHeroHeader: _MuiHeroHeader.default
  };

  var _useState = (0, _react.useState)({
    autoplay: autoplay
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeStep = _useState4[0],
      setActiveStep = _useState4[1];

  var maxSteps = tabs.length;

  var handleNext = function handleNext() {
    var nextStep = activeStep + 1;

    if (nextStep > maxSteps - 1) {
      return setActiveStep(0);
    }

    return setActiveStep(nextStep);
  };

  var handleBack = function handleBack() {
    var nextStep = activeStep - 1;

    if (nextStep < 0) {
      return setActiveStep(maxSteps - 1);
    }

    return setActiveStep(nextStep);
  };

  var onChangeIndex = function onChangeIndex(step) {
    setActiveStep(step);
  };

  var onMouseEnter = function onMouseEnter() {
    if (autoplay) {
      setState({
        autoplay: false
      });
    }
  };

  var onMouseLeave = function onMouseLeave() {
    if (autoplay) {
      setState({
        autoplay: true
      });
    }
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var back = backBtn[0];
  var next = nextBtn[0];
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(AutoPlaySwipeableViews, {
    autoplay: state.autoplay,
    interval: typeof interval === 'string' ? Number(interval) : interval,
    index: activeStep,
    onChangeIndex: onChangeIndex,
    enableMouseEvents: true
  }, tabs.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement(_MuiMobileTab.default, {
      tab: tab.tab[0]
    });
  })), /*#__PURE__*/_react.default.createElement(_MobileStepper.default, {
    className: styles.root,
    steps: maxSteps,
    position: position,
    variant: variant,
    activeStep: activeStep,
    nextButton: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, next ? /*#__PURE__*/(0, _react.createElement)(components[next.component], _objectSpread(_objectSpread({}, next), {}, {
      onClick: handleNext
    })) : null),
    backButton: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, back ? /*#__PURE__*/(0, _react.createElement)(components[back.component], _objectSpread(_objectSpread({}, back), {}, {
      onClick: handleBack
    })) : null)
  }));
};

var _default = MuiMobileStepper;
exports.default = _default;
MuiMobileStepper.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Mui prop: 'bottom', 'static', 'top'
   * Set the positioning type.
   */
  position: function position(props, propName, componentName) {
    var validProps = ['bottom', 'static', 'top'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Mui prop: 'dots', 'progress', 'text'
   * Set the variant type.
   */
  variant: function variant(props, propName, componentName) {
    var validProps = ['dots', 'progress', 'text'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** autoplay will incroment tabs by a interval */
  autoplay: _propTypes.default.bool,

  /** interval to incroment tabs: time in millaseconds */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** MuiMobileTab */
  tabs: function tabs(props, propName, componentName) {
    var components = ['MuiMobileTab'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  },

  /**
   * MuiIconButton,
    MuiButton,
   */
  nextBtn: function nextBtn(props, propName, componentName) {
    var components = ['MuiIconButton', 'MuiButton'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  },

  /**
   * MuiIconButton,
  * MuiButton,
  */
  backBtn: function backBtn(props, propName, componentName) {
    var components = ['MuiIconButton', 'MuiButton'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  }
};
MuiMobileStepper.defaultProps = {
  rootClass: [],
  position: 'static',
  variant: 'dots',
  autoplay: false,
  interval: 3000,
  nextBtn: [],
  backBtn: [],
  tabs: []
};